import DTextField from "components/common/DTextField";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import resource from "pages/EmployeeWorkspace/Resources/civilServiceResource";
/*import RHFSelect from "components/forms/RHFSelect";*/

export default function TabForm({ register, errors, control }) {
    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={8}>
                <DTextField
                    name={resource.fields.accreditation.name}
                    label={resource.fields.accreditation.label}
                    required={resource.fields.accreditation.required}
                    options={resource.fields.accreditation.options ?? []}
                    error={!!errors.accreditation}
                    {...register(resource.fields.accreditation.name)}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.dateTaken.label}
                    required={resource.fields.dateTaken.required}
                    {...register(resource.fields.dateTaken.name)}
                    error={!!errors.dateTaken}
                    helperText={errors.dateTaken?.message}
                    type={resource?.fields?.dateTaken?.type}
                />
            </GridItem>

            <GridItem xs={12} md={12}>
                <DTextField
                    label={resource.fields.placeTaken.label}
                    {...register(resource.fields.placeTaken.name)}
                    error={!!errors.placeTaken}
                    helperText={errors.placeTaken?.message}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.licenseNumber.label}
                    InputLabelProps={{ shrink: true }}
                    {...register(resource.fields.licenseNumber.name)}
                    error={!!errors.licenseNumber}
                    helperText={errors.licenseNumber?.message}
                    type={resource?.fields?.licenseNumber?.type}
                />
            </GridItem>

            <GridItem xs={12} md={4}>
                <DTextField
                    label={resource.fields.validityDate.label}
                    InputLabelProps={{ shrink: true }}
                    {...register(resource.fields.validityDate.name)}
                    error={!!errors.validityDate}
                    helperText={errors.validityDate?.message}
                    type={resource?.fields?.validityDate?.type}
                />
            </GridItem>
        </GridContainer>
    );
}
